import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms55x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms55x/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_codempid: (typeof searchParams.codempid4 !== 'undefined' ? searchParams.codempid4 : ''),
        p_codcomp: (typeof searchParams.codcomp2 !== 'undefined' ? searchParams.codcomp2 : ''),
        p_dteworkst: (typeof searchParams.dteworkst !== 'undefined' ? searchParams.dteworkst.replace(/\//g, '') : ''),
        p_dteworken: (typeof searchParams.dteworken !== 'undefined' ? searchParams.dteworken.replace(/\//g, '') : ''),
        p_typleave: (typeof searchParams.typleave !== 'undefined' ? searchParams.typleave : ''),
        p_dtework: (typeof searchParams.dtework !== 'undefined' ? searchParams.dtework.replace(/\//g, '') : ''),
        p_codapp: (typeof searchParams.codapp !== 'undefined' ? searchParams.codapp : '')
      }
    }
    return instance().get(endpoint + '/hrms55x/index', { params: sendParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms55x/index.js